export default ({ data }, { t }) => {
  const category = data.shopOfTheYearCategory;
  const sotyTitle = t('campaigns', 'shop-of-the-year.title');
  const categoryTitle = t('campaigns', 'shop-of-the-year.category-title', {
    category: category.name,
  });
  const pageTitle = `${sotyTitle} - ${categoryTitle}`;

  const openGraph = [
    { key: 'title', content: pageTitle },
    { key: 'type', content: 'website' },
  ];

  return {
    title: pageTitle,
    openGraph,
    structuredData: undefined,
    hrefLang: [],
  };
};
